export class RisultatiQuestionari {
    id?: string;
    data?: Date;
    stato?: string;
    nome?: string;
    media?: number;
    materiaNome?: string;
    punteggio?: number;
}